export default {
  memberLevel: {
    levelName: '等级名称',
    minPoints: '最小积分',
    maxPoints: '最大积分',
    addLevel: '新增会员层级',
    editLevel: '编辑会员层级'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/mmc/memberLevel.js